var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusQueued({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1.2,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KA---04",
    transform: "translate(-104.000000, -366.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(80.000000, -144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/12px/Status/Queued",
    transform: "translate(24.000000, 510.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4A77F6",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.750000, 2.750000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 1.3125,
    width: 5.25,
    height: 5.25,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3125,0.4375 L4.375,0.4375 C5.34149831,0.4375 6.125,1.22100169 6.125,2.1875 L6.125,5.25 C6.125,5.49162458 6.32087542,5.6875 6.5625,5.6875 C6.80412458,5.6875 7,5.49162458 7,5.25 L7,2.1875 C7,0.737752532 5.82474747,-0.4375 4.375,-0.4375 L1.3125,-0.4375 C1.07087542,-0.4375 0.875,-0.241624578 0.875,0 C0.875,0.241624578 1.07087542,0.4375 1.3125,0.4375 Z",
    id: "Path-16",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusQueued);
export default __webpack_public_path__ + "static/media/status-queued.267f05101443acb4ba4a4b0e8e8f3648.svg";
export { ForwardRef as ReactComponent };